export type ToggleFilterMode = 'multi' | 'single-or-all';

export function isAllSelected(selected: string[], all: string[]): boolean {
  return all.length > 0 && all.every((v) => selected.includes(v));
}

export function selectAll(all: string[]): string[] {
  return [...all];
}

export function isolate(value: string): string[] {
  return [value];
}

/**
 * multi: independent on/off toggles; the last selected option can't be turned off.
 * single-or-all: selection is exactly one option or everything; clicking the lone
 * selected option returns to everything.
 */
export function toggle(selected: string[], value: string, mode: ToggleFilterMode, all: string[]): string[] {
  if (mode === 'single-or-all') {
    if (selected.length === 1 && selected[0] === value) return [...all];
    return [value];
  }
  if (!selected.includes(value)) return [...selected, value];
  if (selected.length > 1) return selected.filter((v) => v !== value);
  return selected; // last one locked on
}
